<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <!-- Tabs -->
  <ul class="nav nav-tabs d-flex" role="tablist">
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" [class.active]="activeTab==='walletStatus'" (click)="setActiveTab('walletStatus')"
        type="button">
        Wallet Status
      </button>
    </li>
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" [class.active]="activeTab==='reports'" (click)="setActiveTab('reports')"
        type="button">
        Reports
      </button>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content mt-3">
    <!-- Wallet Status Tab -->
    <div class="tab-pane fade" [class.show]="activeTab==='walletStatus'" [class.active]="activeTab==='walletStatus'">
      <div class="card shadow-sm border-0">
        <div class="card-body">

          <!-- Header -->
          <div class="row mb-2">
            <div class="col-md-12 col-sm-12">
              <div class="p-3 rounded-3 border bg-light h-100">
                <div class="small text-muted d-flex align-items-center gap-2">
                  <i class="bi bi-wallet"></i>
                  Wallet Withdrawals
                </div>
                <div class="text-muted small mt-1">
                  Select a range, view company totals, expand to see employees, then open employee withdrawals.
                </div>
              </div>
            </div>
          </div>

          <!-- Date Range selectors for Companies -->
          <div class="row g-3 align-items-end mb-3 mt-2">

            <div class="col-md-6">
              <label class="label-text">Search Companies</label>
              <div class="position-relative">
                <input id="searchCompanies" type="text" class="form-control user-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="companySearchText" (input)="performCompanySearch()" />
                <span class="search-icon" (click)="performCompanySearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </div>

            <div class="col-lg-2">
              <label class="label-text">Start Date</label>
              <input type="date" class="form-control" [(ngModel)]="companyStartDate"
                (change)="onCompanyDateRangeChange()" [max]="maxDate"
                [class.is-invalid]="hasInvalidCompanyDateRange()" />
            </div>

            <div class="col-lg-2">
              <label class="label-text">End Date</label>
              <input type="date" class="form-control" [(ngModel)]="companyEndDate" (change)="onCompanyDateRangeChange()"
                [max]="maxDate" [min]="companyMinEndDate" [class.is-invalid]="hasInvalidCompanyDateRange()" />
            </div>

            <button class="btn btn-secondary col-md-2" (click)="resetCompanyDateFilters()">
              <i class="bi bi-arrow-clockwise me-1"></i>
              Reset
            </button>

          </div>

          <!-- States -->
          <div *ngIf="isCompaniesLoading" class="text-muted">Loading companies...</div>
          <!-- <div *ngIf="companiesError" class="text-danger">{{ companiesError }}</div> -->

          <!-- Empty State -->
          <div *ngIf="!isCompaniesLoading && (companiesError || filteredCompanies.length === 0)"
            class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">
              {{ companiesError ? companiesError : 'No Companies Found.' }}
            </p>
          </div>


          <!-- Companies table with expandable rows -->
          <div *ngIf="filteredCompanies.length > 0" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start" style="width: 48px;"></th>
                  <th class="table-title text-start">Company Name </th>
                  <th class="table-title text-start">Company ID</th>
                  <th class="table-title text-end">Total Wallet In Amount (LKR)</th>
                  <th class="table-title text-end">Total Wallet In Transfer Fee (LKR)</th>
                  <th class="table-title text-end">Total Wallet Withdrawal (LKR)</th>
                  <th class="table-title text-end">Total Wallet Withdrawal Fee (LKR)</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let c of pagedCompanies">
                  <!-- Company row -->
                  <tr class="clickable-row" role="button" tabindex="0" (click)="toggleExpand(c)">
                    <td class="text-start">
                      <button class="btn p-0" style="background: none; border: none;"
                        (click)="$event.stopPropagation(); toggleExpand(c)"
                        [attr.aria-expanded]="isExpanded(c.companyId)" [attr.aria-controls]="'emp-row-' + c.companyId">
                        <i class="bi" [ngClass]="isExpanded(c.companyId) ? 'bi-chevron-down' : 'bi-chevron-right'"
                          style="font-size: 1.05rem; color: var(--primary-color);"></i>
                      </button>
                    </td>
                    <td class="table-data-text text-start">{{ c.companyName }}</td>
                    <td class="table-data-text text-start">{{ c.companyId }}</td>
                    <td class="table-data-text text-end">{{ (c.totalWalletInBalance ?? 0) | number:'1.2-2' }}</td>
                    <td class="table-data-text text-end">{{ (c.totalWalletInTransferFee ?? 0) | number:'1.2-2' }}</td>
                    <td class="table-data-text text-end">{{ (c.totalWalletOutBalance ?? c.totalWalletWithdrawals ??
                      c.totalWalletWithdrawal ?? c.totalWithdrawals ?? 0) | number:'1.2-2' }}</td>
                    <td class="table-data-text text-end">{{ (c.totalWalletOutTransferFee ?? 0) | number:'1.2-2' }}</td>
                  </tr>

                  <!-- Expanded row: employees -->
                  <tr *ngIf="isExpanded(c.companyId)" [attr.id]="'emp-row-' + c.companyId">
                    <td></td>
                    <td colspan="6">
                      <div class="emp-sub-section rounded-3 border bg-light">

                        <!-- Section label -->
                        <div class="d-flex align-items-center gap-2 mb-2 small">
                          <i class="bi bi-people" style="color: var(--secondary-color);"></i>
                          <span class="fw-semibold" style="color: var(--secondary-color);">Employees</span>
                        </div>

                        <!-- Loading / Error / Empty states -->
                        <div *ngIf="isEmployeesLoadingMap[c.companyId]" class="text-muted small">Loading…</div>
                        <div *ngIf="employeesErrorMap[c.companyId]" class="text-danger small">{{ employeesErrorMap[c.companyId] }}</div>
                        <div *ngIf="!isEmployeesLoadingMap[c.companyId] && !employeesErrorMap[c.companyId] && (employeesByCompany.get(+c.companyId)?.length ?? 0) === 0"
                          class="text-muted small">No employees found.</div>

                        <!-- Enhanced employee section -->
                        <ng-container *ngIf="!isEmployeesLoadingMap[c.companyId] && !employeesErrorMap[c.companyId] && (employeesByCompany.get(+c.companyId)?.length ?? 0) > 0">

                          <!-- Toolbar: filter | count | spacer | rows-per-page | pager -->
                          <div class="emp-toolbar">
                            <!-- Filter input -->
                            <div class="emp-filter-wrap">
                              <i class="bi bi-search emp-filter-icon"></i>
                              <input
                                class="emp-filter-input"
                                type="text"
                                placeholder="Filter by ID or Name…"
                                [value]="empFilterMap[c.companyId] || ''"
                                (input)="filterEmployee(+c.companyId, $any($event).target.value)"
                              />
                            </div>

                            <!-- Count badge -->
                            <span class="emp-count-badge">
                              <b>{{ getEmpFilteredCount(+c.companyId) }}</b> of {{ employeesByCompany.get(+c.companyId)?.length }} employee{{ (employeesByCompany.get(+c.companyId)?.length ?? 0) !== 1 ? 's' : '' }}
                            </span>

                            <div class="flex-grow-1"></div>

                            <!-- Rows per page -->
                            <span class="small text-muted emp-rpp-label">Rows per page</span>
                            <select
                              class="emp-rpp-select"
                              (change)="setEmpPageSize(+c.companyId, +$any($event).target.value)"
                            >
                              <option *ngFor="let n of [3, 5, 10, 25]" [value]="n" [selected]="getEmpPageSize(+c.companyId) === n">{{ n }}</option>
                            </select>

                            <!-- Pager -->
                            <div class="emp-pager">
                              <button
                                class="emp-pg-btn"
                                [disabled]="getEmpCurrentPage(+c.companyId) <= 1"
                                (click)="setEmpPage(+c.companyId, getEmpCurrentPage(+c.companyId) - 1)"
                              >&#8249;</button>
                              <button
                                *ngFor="let p of getEmpPageNumbers(+c.companyId)"
                                class="emp-pg-btn"
                                [class.active]="p === getEmpCurrentPage(+c.companyId)"
                                (click)="setEmpPage(+c.companyId, p)"
                              >{{ p }}</button>
                              <button
                                class="emp-pg-btn"
                                [disabled]="getEmpCurrentPage(+c.companyId) >= getEmpTotalPages(+c.companyId)"
                                (click)="setEmpPage(+c.companyId, getEmpCurrentPage(+c.companyId) + 1)"
                              >&#8250;</button>
                            </div>
                          </div>

                          <!-- Table with frozen first two columns -->
                          <div class="emp-table-outer">
                            <div class="emp-table-scroll">
                              <table class="table table-bordered mb-0 emp-sub-table">
                                <thead>
                                  <tr>
                                    <th class="table-title text-start align-middle emp-col-f1">Employee ID</th>
                                    <th class="table-title text-start align-middle emp-col-f2">Employee Name</th>
                                    <th class="table-title text-end align-middle emp-col-num">Wallet Opening Balance (LKR)</th>
                                    <th class="table-title text-end align-middle emp-col-num">Earn Wage Withdrawal (LKR)</th>
                                    <th class="table-title text-end align-middle emp-col-num">Withdrawal Fee (LKR)</th>
                                    <th class="table-title text-end align-middle emp-col-num">Wallet In Amount (LKR)</th>
                                    <th class="table-title text-end align-middle emp-col-num">Wallet Out Amount (LKR)</th>
                                    <th class="table-title text-end align-middle emp-col-num">Transfer Fee (LKR)</th>
                                    <th class="table-title text-end align-middle emp-col-num">Wallet Closing Balance (LKR)</th>
                                    <th class="table-title text-end align-middle emp-col-aod">
                                      As Of Date Wallet Balance (LKR)<br>
                                      <small class="emp-aod-header-date" style="color: var(--secondary-color) !important;">({{ systemDate | date: 'yyyy-MM-dd' }})</small>
                                    </th>
                                    <th class="table-title text-center align-middle emp-col-act">
                                      <i class="bi bi-eye" title="View Details" style="color: var(--secondary-color) !important;"></i>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <!-- Empty state when filter returns nothing -->
                                  <tr *ngIf="getEmpFilteredCount(+c.companyId) === 0" class="emp-empty-row">
                                    <td colspan="11">No employees match your search "{{ empFilterMap[c.companyId] }}"</td>
                                  </tr>
                                  <!-- Employee rows -->
                                  <tr *ngFor="let emp of getPagedEmployees(+c.companyId)">
                                    <td class="table-data-text text-start align-middle emp-col-f1">
                                      <span>{{ emp.employeeId }}</span>
                                    </td>
                                    <td class="table-data-text text-start align-middle emp-col-f2">{{ emp.employeeName }}</td>
                                    <td class="table-data-text text-end align-middle">{{ emp.walletOpeningBalance | number:'1.2-2' }}</td>
                                    <td class="table-data-text text-end align-middle">{{ emp.totalWithdrawAmount | number:'1.2-2' }}</td>
                                    <td class="table-data-text text-end align-middle">{{ emp.totalTransferFeeDeduction | number:'1.2-2' }}</td>
                                    <td class="table-data-text text-end align-middle">{{ emp.totalFinalBalance | number:'1.2-2' }}</td>
                                    <td class="table-data-text text-end align-middle">{{ emp.totalWalletOutBalance | number:'1.2-2' }}</td>
                                    <td class="table-data-text text-end align-middle">{{ emp.transactionCost | number:'1.2-2' }}</td>
                                    <td class="table-data-text text-end align-middle">{{ emp.walletClosingBalance | number:'1.2-2' }}</td>
                                    <td class="table-data-text text-end align-middle">{{ emp.currentWalletAmount | number:'1.2-2' }}</td>
                                    <td class="table-data-text text-center align-middle emp-col-act">
                                      <button class="btn p-0" style="background: none; border: none;"
                                        (click)="$event.stopPropagation(); openEmployee(c, emp)"
                                        [attr.data-bs-toggle]="'offcanvas'"
                                        [attr.data-bs-target]="'#employeeWithdrawalsOffcanvas'">
                                        <i class="bi bi-arrow-right" style="color: var(--secondary-color) !important;"></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <!-- Showing X–Y of Z label -->
                          <div *ngIf="getEmpFilteredCount(+c.companyId) > 0" class="emp-showing-label">
                            Showing {{ getEmpShowFrom(+c.companyId) }}–{{ getEmpShowTo(+c.companyId) }} of {{ getEmpFilteredCount(+c.companyId) }} employee{{ getEmpFilteredCount(+c.companyId) !== 1 ? 's' : '' }}
                          </div>

                        </ng-container>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <!-- Pagination toolbar -->
            <app-paginator [dataSource]="filteredCompanies" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
              (pageChange)="onCompaniesPageChange($event)">
            </app-paginator>
          </div>

        </div>
      </div>
    </div>

    <!-- Reports Tab -->
    <div class="tab-pane fade" [class.show]="activeTab==='reports'" [class.active]="activeTab==='reports'">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <!-- Header -->
          <div class="row mb-2">
            <div class="col-md-12 col-sm-12">
              <div class="p-3 rounded-3 border bg-light h-100">
                <div class="small text-muted d-flex align-items-center gap-2">
                  <i class="bi bi-file-earmark-arrow-down"></i>
                  Wallet Withdrawal Reports
                </div>
                <div class="text-muted small mt-1">
                  Select a company and date range to export wallet status reports.
                </div>
              </div>
            </div>
          </div>

          <!-- Filters -->
          <div class="row g-3 align-items-end mb-3 mt-2">
            <!-- <div class="col-md-4">
              <label class="label-text">Company Name</label>
              <select class="form-select company-select-dropdown" [(ngModel)]="selectedReportCompany"
                [disabled]="isReportsCompaniesLoading">
                <option [ngValue]="null">Select Company</option>
                <option *ngFor="let company of reportsCompanies" [ngValue]="company">
                  {{ company.companyName }} ({{ company.companyId }})
                </option>
              </select>
              <div *ngIf="isReportsCompaniesLoading" class="text-muted small mt-1">Loading companies...</div>
              <div *ngIf="reportsCompaniesError" class="text-danger small mt-1">{{ reportsCompaniesError }}</div>
            </div> -->
            <div class="col-md-4">
              <label class="label-text">Company Name</label>

              <div class="searchable-dropdown">
              
                <!-- Visible Search Input -->
                <div class="dropdown-input-wrapper">
                  <input type="text" class="form-control shadow-none input-text" [value]="getSelectedReportCompanyName()"
                    (input)="onReportCompanySearchChange($event)" (focus)="openReportCompanyDropdown()" (blur)="onReportCompanyBlur()"
                    placeholder="Select Company" autocomplete="off" [disabled]="isReportsCompaniesLoading">
                  <span class="input-group-text"><i class="bi bi-chevron-down"></i></span>
                </div>
              
                <!-- Dropdown Options List -->
                <div class="dropdown-list" *ngIf="reportCompanyDropdownOpen && filteredReportCompanies().length > 0">
              
                  <!-- "Select Company" clear option -->
                  <div class="dropdown-item" [class.selected]="!selectedReportCompany" (mousedown)="selectReportCompany(null)">
                    <span class="bank-name">Select Company</span>
                  </div>
              
                  <!-- Company rows — "All Companies" sentinel rendered differently -->
                  <div class="dropdown-item" *ngFor="let company of filteredReportCompanies()"
                    (mousedown)="selectReportCompany(company)"
                    [class.selected]="selectedReportCompany?.companyId === company.companyId">
              
                    <!-- All Companies option temporarily commented out
                    <span class="bank-name" *ngIf="company.companyId === -1; else normalCompany">
                      <i class="bi bi-buildings me-1"></i><strong>All Companies</strong>
                    </span>
                    -->
                    <span class="bank-name" *ngIf="company.companyId !== -1">{{ company.companyName }} ({{ company.companyId }})</span>
              
                  </div>
                </div>
              
                <!-- No Results Message -->
                <div class="dropdown-list no-results" *ngIf="reportCompanyDropdownOpen && filteredReportCompanies().length === 0">
                  <div class="dropdown-item">No companies found</div>
                </div>        
              </div>

              <div *ngIf="isReportsCompaniesLoading" class="text-muted small mt-1">
                Loading companies...
              </div>
              <div *ngIf="reportsCompaniesError" class="text-danger small mt-1">
                {{ reportsCompaniesError }}
              </div>
            </div>
            <div class="col-md-3">
              <label class="label-text">Start Date</label>
              <input type="date" class="form-control" [(ngModel)]="reportStartDate" (change)="onStartDateChange()"
                [max]="maxDate" [class.is-invalid]="hasInvalidDateRange()" />
            </div>
            <div class="col-md-3">
              <label class="label-text">End Date</label>
              <input type="date" class="form-control" [(ngModel)]="reportEndDate" (change)="onEndDateChange()"
                [max]="maxDate" [min]="minEndDate" [class.is-invalid]="hasInvalidDateRange()" />
            </div>
            <button class="btn btn-secondary col-md-2" (click)="resetReportFilters()">
              <i class="bi bi-arrow-clockwise me-1"></i>
              Reset Filters
            </button>
          </div>

          <!-- Report Download Actions -->
          <div class="row gy-3">
            <div class="col-lg-4 col-md-6">
              <div class="p-3 border rounded-3 h-100 wallet-report-card card-glow">
                <div class="d-flex align-items-center gap-2 mb-2">
                  <i class="bi bi-clipboard-data text-primary"></i>
                  <span class="fw-semibold">Wallet Summary Report</span>
                </div>
                <p class="text-muted small mb-3">
                  Download the summary of wallet balances and fees for the selected company and date range.
                </p>
                <button class="btn btn-primary w-100" [disabled]="!canExportReport() || isDownloading.walletSummary"
                  (click)="downloadReport('walletSummary')">
                  <span *ngIf="!isDownloading.walletSummary">
                    <i class="bi bi-download me-1" style="color: white !important;"></i>
                    Wallet Summary Report
                  </span>
                  <span *ngIf="isDownloading.walletSummary">
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    Preparing...
                  </span>
                </button>
                <div *ngIf="reportDownloadErrors.walletSummary" class="text-danger small mt-2">
                  {{ reportDownloadErrors.walletSummary }}
                </div>
              </div>
            </div>

            <div class="col-lg-8 col-md-6">
              <div class="p-3 border rounded-3 h-100 wallet-report-card card-glow">
                <div class="d-flex align-items-center gap-2 mb-2">
                  <i class="bi bi-diagram-3 text-primary"></i>
                  <span class="fw-semibold">Wallet Transaction Report</span>
                </div>
                <p class="text-muted small mb-3">
                  Export detailed transaction history. Choose the report you need below.
                </p>
                <div class="d-flex flex-column gap-2">
                  <div>
                    <button class="btn btn-outline-primary w-100"
                      [disabled]="!canExportReport() || isDownloading.walletIn" (click)="downloadReport('walletIn')">
                      <span *ngIf="!isDownloading.walletIn">
                        <i class="bi bi-download me-1" style="color: #1c6ce6 !important;"></i>
                        Wallet In Report
                      </span>
                      <span *ngIf="isDownloading.walletIn">
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Preparing...
                      </span>
                    </button>
                    <div *ngIf="reportDownloadErrors.walletIn" class="text-danger small mt-2">
                      {{ reportDownloadErrors.walletIn }}
                    </div>
                  </div>
                  <div>
                    <button class="btn btn-outline-primary w-100"
                      [disabled]="!canExportReport() || isDownloading.walletOut" (click)="downloadReport('walletOut')">
                      <span *ngIf="!isDownloading.walletOut">
                        <i class="bi bi-download me-1" style="color: #1c6ce6 !important;"></i>
                        Wallet Out Report
                      </span>
                      <span *ngIf="isDownloading.walletOut">
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Preparing...
                      </span>
                    </button>
                    <div *ngIf="reportDownloadErrors.walletOut" class="text-danger small mt-2">
                      {{ reportDownloadErrors.walletOut }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Validation Message -->
          <div *ngIf="hasInvalidDateRange()" class="alert alert-warning mt-2">
            <i class="bi bi-exclamation-triangle me-2"></i>
            Start date must be before or equal to end date.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Offcanvas: Employee Withdrawals -->
<div class="offcanvas offcanvas-end w-70" tabindex="-1" id="employeeWithdrawalsOffcanvas"
  aria-labelledby="employeeWithdrawalsOffcanvasLabel" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="offcanvas-header">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-10 d-flex align-items-center">
          <h5 class="offcanvas-title d-flex align-items-center gap-2 mb-0" id="employeeWithdrawalsOffcanvasLabel">
            <i class="bi fs-5 bi-person-lines-fill"></i>
            {{ selectedCompany?.companyName || 'Company' }} — {{ selectedEmployee?.employeeName || 'Employee' }}
            <!-- <span class="ms-2 text-muted small">({{ selectedMonthLabel }} {{ selectedYear }})</span> -->
          </h5>
        </div>
        <div class="col-2 text-end">
          <span type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></span>
        </div>
      </div>
    </div>
  </div>

  <div class="offcanvas-body">
    <div *ngIf="selectedEmployee as se">

      <!-- Filters -->
      <div class="row g-3 align-items-end">
        <div class="col-md-6">
          <label class="label-text">Search</label>
          <input type="text" class="form-control user-search-input shadow-none" placeholder="Type here..."
            [(ngModel)]="withdrawalSearchText" (input)="performWithdrawalSearch()" />
        </div>
      </div>

      <!-- States -->
      <div class="mt-3" *ngIf="isWithdrawalsLoading">Loading withdrawals...</div>
      <div class="mt-2 text-danger" *ngIf="withdrawalsError">{{ withdrawalsError }}</div>
      <!-- Empty State -->
      <div *ngIf="!isWithdrawalsLoading && !withdrawalsError && withdrawals.length === 0" class="text-center py-5">
        <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
        <p class="text-muted">
          No withdrawals found for the selected period.
        </p>
      </div>

      <div
        *ngIf="!isWithdrawalsLoading && !withdrawalsError && withdrawals.length > 0 && filteredWithdrawals.length === 0"
        class="text-center py-5">
        <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
        <p class="text-muted">
          No matching results for "{{ withdrawalSearchText }}".
        </p>
      </div>

      <!-- Withdrawal table -->
      <div *ngIf="filteredWithdrawals.length > 0" class="table-responsive-wrapper mt-3">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="table-title text-start">Type</th>
              <th class="table-title text-start">Date</th>
              <th class="table-title text-end">Payment (LKR)</th>
              <th class="table-title text-end">Fee (LKR)</th>
              <th class="table-title text-end">Wallet In / Out (LKR)</th>
              <th class="table-title text-start">Details</th>
              <th class="table-title text-start">Reference</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let w of pagedWithdrawals">
              <!-- Transaction Type -->
              <td class="table-data-text text-start">
                <span class="badge" [ngClass]="getTransactionTypeBadgeClass(w.transactionType)">
                  {{ getTransactionTypeLabel(w.transactionType) }}
                </span>
              </td>

              <!-- Date -->
              <td class="table-data-text text-start">
                {{ formatDateTime(w.transactionCreatedDate || w.transactionDate) }}
              </td>

              <!-- Payment Amount -->
              <td class="table-data-text text-end">
                {{ (w.paymentAmount ?? 0) | number:'1.2-2' }}
              </td>

              <!-- Transfer Fee -->
              <td class="table-data-text text-end">
                {{ (w.transferFee ?? 0) | number:'1.2-2' }}
              </td>

              <!-- Total Amount -->
              <td class="table-data-text text-end">
                {{ (w.totalWalletOutAmount ?? 0) | number:'1.2-2' }}
              </td>

              <!-- Details Column (Bank OR CTCQR info) -->
              <td class="table-data-text text-start">
                <!-- Bank Transfer Details -->
                <div *ngIf="w.transactionType === 'PAYANYONE_TRANSFER' || w.transactionType === 'BANK_TRANSFER'">
                  <div><strong>{{ w.bankName || '-' }}</strong></div>
                  <div class="text-muted small">Acc No: {{ w.bankAccountNumber || '-' }}</div>
                </div>

                <!-- CTCQR Details -->
                <div *ngIf="w.transactionType?.includes('CTCQR')">
                  <div>
                    <strong>{{ w.receiverUserName || '-' }}</strong>
                  </div>
                  <div class="text-muted small">Wallet: {{ w.receiverWalletAccountNumber || '-' }}</div>
                </div>

                <!-- EWW Details -->
                <div *ngIf="w.transactionType?.includes('EWW')">
                  <div class="text-muted small">Earn wage Withdrawal</div>
                </div>
              </td>

              <!-- Reference Note -->
              <td class="table-data-text text-start">
                {{ w.refNote || w.referenceNote || '-' }}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination toolbar -->
        <app-paginator [dataSource]="filteredWithdrawals" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
          (pageChange)="onWithdrawalPageChange($event)">
        </app-paginator>
      </div>
    </div>
  </div>